import Excel from 'exceljs';
import { saveAs } from 'file-saver';

export const basicExcelExport = async function({
  headers = [],
  rows = [],
  title = 'Excel munkafüzet',
  author = '',
  headerStyle = { font: { bold: true } },

  beforeDownload = null,
}) {
  var workbook = new Excel.Workbook();
  workbook.creator = author;
  workbook.lastModifiedBy = author;

  var worksheet = workbook.addWorksheet('Munkalap');

  // Header hozzáadása
  worksheet.columns = headers;

  // Sorok hozzáadása
  rows.forEach((row, rowNumber) => {
    let tmpRow = [];
    for (let i = 0; i < headers.length; i++) {
      if (headers[i].renderFn) {
        tmpRow.push(headers[i].renderFn(row[headers[i].key]));
      } else {
        tmpRow.push(row[headers[i].key]);
      }
    }
    worksheet.addRow(tmpRow);
  });

  // Header stílus
  if (headerStyle) {
    let header = worksheet.getRow(1);
    header.eachCell(c => {
      c.style = headerStyle;
    });
  }

  // Sor stílus
  if (headers.length > 0) {
    for (let i = 2; i <= worksheet.rowCount; i++) {
      let row = worksheet.getRow(i);
      row.eachCell((c, cIdx) => {
        c.style = {
          ...c.style,
          ...(headers[cIdx - 1].dataStyle || ExcelColFormats.Empty),
        };
      });
    }
  }
  // Callback szerkesztésre
  if (beforeDownload) {
    beforeDownload(workbook);
  }

  var wbout = await workbook.xlsx.writeBuffer({
    filename: title,
    useStyles: true,
  });

  saveAs(
    new Blob([wbout], { type: 'application/octet-stream' }),
    `${title}.xlsx`
  );
};
export const ExcelColFormats = Object.freeze({
  Empty: {},
  String: { alignment: { horizontal: 'left' } },
  Number: { numFmt: '#,##0' },
  DateTime: { numFmt: 'yyyy.mm.dd hh:mm' },
  Date: { numFmt: 'yyyy.mm.dd' },
  Time: { numFmt: 'hh:mm' },
});
